import { css } from '@emotion/react';
import { Link } from 'react-router-dom';
import { UIColorPalette } from './ColorPalette';

type DevLink = {
  to: string;
  label: string;
  description: string;
};

const adminLinks: DevLink[] = [
  {
    to: '/dev/admin',
    label: 'Admin Dashboard',
    description: 'Server environment, channel connections',
  },
  {
    to: '/dev/users',
    label: 'Users',
    description: 'Browse registered users',
  },
  {
    to: '/dev/game-history-list',
    label: 'Game History',
    description: 'View all completed and ongoing games',
  },
];

const debugLinks: DevLink[] = [
  {
    to: '/debug_card',
    label: 'Card Renderer',
    description: 'Preview and debug card rendering',
  },
  {
    to: '/debug_reference',
    label: 'Reference Card',
    description: 'Preview reference card layouts',
  },
  {
    to: '/debug_tribute',
    label: 'Tribute Renderer',
    description: 'Preview tribute card layouts',
  },
  {
    to: '/debug_tribute2',
    label: 'Tribute Renderer v2',
    description: 'Preview new tribute card layout',
  },
  {
    to: '/debug_symbols',
    label: 'Symbol Reference',
    description: 'View all game symbols',
  },
  {
    to: '/debug_basic_board',
    label: 'Basic Board',
    description: 'Basic row board piece for printing',
  },
  {
    to: '/print',
    label: 'Print Cards',
    description: 'PDF generation for physical printing',
  },
];

export default function DevLandingPage() {
  return (
    <div css={Styles.page}>
      <h1 css={Styles.title}>Developer Tools</h1>

      <section css={Styles.section}>
        <h2 css={Styles.sectionTitle}>Admin</h2>
        <div css={Styles.grid}>
          {adminLinks.map((link) => (
            <Link key={link.to} to={link.to} css={Styles.card}>
              <div css={Styles.cardLabel}>{link.label}</div>
              <div css={Styles.cardDescription}>{link.description}</div>
            </Link>
          ))}
        </div>
      </section>

      {process.env.NODE_ENV === 'development' && (
        <section css={Styles.section}>
          <h2 css={Styles.sectionTitle}>Debug Tools</h2>
          <div css={Styles.grid}>
            {debugLinks.map((link) => (
              <Link key={link.to} to={link.to} css={Styles.card}>
                <div css={Styles.cardLabel}>{link.label}</div>
                <div css={Styles.cardDescription}>{link.description}</div>
              </Link>
            ))}
          </div>
        </section>
      )}
    </div>
  );
}

const Styles = {
  page: css({
    padding: 16,
    maxWidth: 800,
    margin: '0 auto',
  }),
  title: css({
    fontSize: '2rem',
    fontWeight: 'bold',
    marginBottom: '1.5rem',
    textAlign: 'center',
  }),
  section: css({
    marginBottom: 32,
  }),
  sectionTitle: css({
    fontSize: '1.25rem',
    marginBottom: 16,
    borderBottom: `1px solid ${UIColorPalette.listItemBottomBorder}`,
    paddingBottom: 8,
  }),
  grid: css({
    display: 'grid',
    gridTemplateColumns: 'repeat(auto-fill, minmax(220px, 1fr))',
    gap: 12,
  }),
  card: css({
    display: 'block',
    padding: 16,
    backgroundColor: UIColorPalette.listBackground,
    borderRadius: 8,
    border: `1px solid ${UIColorPalette.listItemBottomBorder}`,
    textDecoration: 'none',
    color: 'inherit',
    transition: 'background-color 0.15s',
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.08)',
    },
  }),
  cardLabel: css({
    fontWeight: 'bold',
    marginBottom: 4,
  }),
  cardDescription: css({
    fontSize: 14,
    opacity: 0.7,
  }),
};
